import styled from "styled-components";
import { colorTwoBright } from "../../../globalStyles/colors/scoutColors";

export const ReportSectionHeader = styled("div")`
  width: 100%;
  margin-bottom: 40px;
`;

export const ReportH1 = styled("h1")`
  font-size: 45px;
  line-height: 55px;
  letter-spacing: 0;
  font-weight: 800;
  color: ${colorTwoBright};
  margin-bottom: 0;
`;

export const ReportH2 = styled("h2")`
  font-size: 36px;
  margin: 0.5rem 0;
  color: rgba(0, 0, 0, 0.95);
  font-weight: bold;
  margin: 0 0 10px;
`;

export const ReportH3 = styled("h3")`
  font-size: 20px;
  line-height: 30px;
  margin: 20px 0 0;
  font-weight: 800;
  margin: 0 0 10px;
  padding: 0;
`;

export const ReportH4 = styled("h4")`
  font-family: Manrope;
  font-size: 20px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.95;
  letter-spacing: normal;
  color: #000000;
  margin: 0 0 10px;
  padding: 2px 2px 2px 0;
  display: inline-block;
`;

export const ReportH5 = styled("h5")`
  font-family: Manrope;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  margin: 0 0 8px;
  padding: 2px 2px 2px 0;
  display: inline-block;
`;

export const ReportDateBlockHeaderText = styled("span")`
  font-size: 14px;
  margin: 2px 0 0 8px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  display: inline-block;
`;

export const BodyText = styled("p")`
  font-family: Manrope, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333;
`;

export const ReportBodyTextLarge = styled(BodyText)`
  font-size: 18px;
  line-height: 28px;
`;

export const ReportP = styled("p")`
  line-height: 20px;
`;

export const ReportSectionNumber = styled("h4")`
  font-size: 18px;
  line-height: 29px;
  letter-spacing: 0;
  color: ${colorTwoBright};
  margin: 0;
  padding: 0;
`;

export const ReportCategoryHeader = styled("div")`
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
`;

export const ReportCategoryText = styled("div")`
  font-size: 13px;
`;
